import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import _ from 'lodash'

import FinanceTable from '../FinanceTable'
import SingleBarGraph from './components/SingleBarGraph'

import Banner from '../../assets/modules/finance/banner.gif'

import { LOCALE_PREFIX } from './constants'
import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
@injectIntl
export default class Fstmt extends Component {
    static propTypes = {
        assets: PropTypes.array,
        assetsShowDataTable: PropTypes.bool,
        assetsYear: PropTypes.number,
        block: PropTypes.string.isRequired,
        cashFlow: PropTypes.object,
        customData: PropTypes.object,
        data: PropTypes.object,
        fstmtChangeCurrentStandard: PropTypes.func.isRequired,
        fstmtChangeDataTableActive: PropTypes.func.isRequired,
        fstmtGraphChangeYear: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        liabilities: PropTypes.array,
        liabilitiesShowDataTable: PropTypes.bool,
        liabilitiesYear: PropTypes.number,
        module: PropTypes.string.isRequired,
        results: PropTypes.object,
        showBanner: PropTypes.bool.isRequired,
    }

    handleChangeTableActive = (dataType, active) => {
        const { module, id, block, customData, fstmtChangeDataTableActive } = this.props

        const newCustomData = {
            ...customData,
            summary: {
                ...customData.summary,
                [dataType]: {
                    ...customData.summary[`${dataType}`],
                    showDataTable: active,
                },
            },
        }

        fstmtChangeDataTableActive(module, id, block, newCustomData)
    }

    handleChangeGraphYear = (dataType, year) => {
        const { module, id, block, customData, fstmtGraphChangeYear } = this.props

        const newCustomData = {
            ...customData,
            summary: {
                ...customData.summary,
                [dataType]: {
                    ...customData.summary[`${dataType}`],
                    year,
                },
            },
        }

        fstmtGraphChangeYear(module, id, block, newCustomData)
    }

    handleCurrentStandardChange = (tableType, standardType) => {
        const { module, id, block, level, fstmtChangeCurrentStandard } = this.props

        fstmtChangeCurrentStandard(module, id, block, level, tableType, standardType)
    }

    handleBannerClick = () => {
        window.open('https://www.dnb.com/cs-cz/cz/financni-analyza-odvetvi/', '_blank')
    }

    render() {
        const {
            assets,
            liabilities,
            data,
            intl,
            id,
            level,
            assetsYear,
            assetsShowDataTable,
            liabilitiesYear,
            liabilitiesShowDataTable,
            results,
            cashFlow,
            showBanner,
        } = this.props

        const transformedLevel = parseInt(level.split(',').slice(-1).pop(), 10)

        return (
            <div className={'financial-results-container'}>
                <div className={'data-graphs-container'}>
                    {!_.isEmpty(assets) && (
                        <div className={'data-graph-container'}>
                            <div className={'graph-title'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.activesSum`} />
                            </div>
                            <SingleBarGraph
                                id={id}
                                data={assets}
                                dataType={'assets'}
                                year={assetsYear}
                                showDataTable={assetsShowDataTable}
                                handleChangeTableActive={this.handleChangeTableActive}
                                handleChangeGraphYear={this.handleChangeGraphYear}
                            />
                        </div>
                    )}
                    {!_.isEmpty(liabilities) && (
                        <div className={'data-graph-container'}>
                            <div className={'graph-title'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.passivesSum`} />
                            </div>
                            <SingleBarGraph
                                id={id}
                                data={liabilities}
                                dataType={'liabilities'}
                                year={liabilitiesYear}
                                showDataTable={liabilitiesShowDataTable}
                                handleChangeTableActive={this.handleChangeTableActive}
                                handleChangeGraphYear={this.handleChangeGraphYear}
                            />
                        </div>
                    )}
                </div>
                <div className={'finance-table-wrapper'}>
                    <FinanceTable
                        id={`${id}`}
                        currentStandard={_.get(results, 'currentStandard', null)}
                        changeCurrentStandard={this.handleCurrentStandardChange}
                        data={_.get(results, 'table.data', [])}
                        isAdvanced={transformedLevel > 10}
                        sectionsDefinition={_.get(results, 'table.sectionsDefinition', [])}
                        title={intl.formatMessage({ id: `${LOCALE_PREFIX}.tableTitle` })}
                        showUnitsAndCurr
                        showRowTooltips={false}
                        standards={_.get(data, 'statements.standard', [])}
                        tableType={'results'}
                        numberMagnitude={1000}
                        decimalPlaces={0}
                    />
                </div>
                <div className={'finance-table-wrapper'}>
                    {!_.isEmpty(_.get(data, 'statements.cashFlow')) && transformedLevel > 30 && (
                        <FinanceTable
                            id={`${id}`}
                            currentStandard={_.get(cashFlow, 'currentStandard', null)}
                            changeCurrentStandard={this.handleCurrentStandardChange}
                            data={_.get(cashFlow, 'table.data', [])}
                            isAdvanced={transformedLevel > 10}
                            sectionsDefinition={_.get(cashFlow, 'table.sectionsDefinition', [])}
                            title={intl.formatMessage({ id: `${LOCALE_PREFIX}.cashflowTitle` })}
                            showUnitsAndCurr
                            showRowTooltips={false}
                            standards={_.get(data, 'statements.cashFlow', [])}
                            tableType={'cashFlow'}
                            numberMagnitude={1000}
                            decimalPlaces={0}
                        />
                    )}
                </div>
                {showBanner && (
                    <div className={'finance-banner'}>
                        <div onClick={this.handleBannerClick}>
                            <img src={Banner} alt="Loading..." />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
